import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

export const getProjectsApi = (params = {}) => {
  return axios.get(`${API_BASE_URL}/api/admin/projects`, { params });
};

export const createProjectApi = (data) => {
  return axios.post(`${API_BASE_URL}/api/admin/projects`, data);
};

export const updateProjectApi = (data) => {
  return axios.post(`${API_BASE_URL}/api/admin/projects/update`, data);
};

export const deleteProjectApi = (id) => {
  return axios.delete(`${API_BASE_URL}/api/admin/projects/${id}`);
};
